export default __webpack_public_path__ + "static/media/DSC64006.9e90e0dc.jpg";